import React from "react";
import PropTypes from "prop-types";
import { TextField as TextFieldUI } from "@material-ui/core";
import useStyles from "./useStyles";
import AutocompleteMui from "@material-ui/lab/Autocomplete";

function Autocomplete({
    value,
    name,
    type,
    helperText,
    options,
    getOptionLabel,
    renderOption,
    valueKey,
    labelKey,
    onChange,
    multiple,
    limitTags,
    getOptionSelected,
    error,
    label,
    ...rest
}) {
    const classes = useStyles();

    function getOptionLabelHandler() {
        if (getOptionLabel) {
            return getOptionLabel;
        } else {
            return (option) => {
                if (option) {
                    const value = option[valueKey];
                    const label = option[labelKey];
                    if (value && label) {
                        return `(${value}) ${label}`;
                    }

                    return "";
                }

                return "";
            };
        }
    }

    function renderOptionHandler() {
        if (renderOption) {
            return renderOption;
        } else {
            return (option) => <React.Fragment>{getOptionLabelHandler()(option)}</React.Fragment>;
        }
    }

    return (
        <AutocompleteMui
            multiple={multiple}
            limitTags={limitTags}
            disabled={rest.disabled}
            className={classes.autocomplete}
            options={options}
            classes={{
                option: classes.option,
            }}
            autoHighlight
            getOptionLabel={getOptionLabelHandler()}
            renderOption={renderOptionHandler()}
            onChange={(e, val, r) => {
                onChange && typeof onChange === "function" && onChange(val);
            }}
            value={value}
            renderInput={(params) => (
                <TextFieldUI
                    placeholder="Select..."
                    label={label}
                    {...params}
                    {...rest}
                    name={name}
                    type={type}
                    helperText={error || helperText}
                    error={Boolean(error)}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: "off", // disable autocomplete and autofill
                    }}
                />
            )}
            getOptionSelected={getOptionSelected}
        />
    );
}

Autocomplete.propTypes = {
    value: PropTypes.any,
    name: PropTypes.string,
    type: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
    margin: PropTypes.string,
    fullWidth: PropTypes.bool,
    helperText: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getOptionLabel: PropTypes.func,
    renderOption: PropTypes.func,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,
    onChange: PropTypes.func,
    getOptionSelected: PropTypes.func,
    error: PropTypes.string,
    label: PropTypes.string,
};

Autocomplete.defaultProps = {
    type: "text",
    name: undefined,
    variant: "outlined",
    size: "small",
    margin: "normal",
    fullWidth: true,
    helperText: undefined,
    getOptionLabel: undefined,
    renderOption: undefined,
    valueKey: "value",
    labelKey: "label",
    onChange: undefined,
    getOptionSelected: undefined,
    error: undefined,
    label: undefined,
};

export default Autocomplete;
